import { Trash2, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Floating bar shown when N rows are selected. Rendered only for admin. */
export default function BulkBar({ count, onClear, onDelete, onDuplicate, entityLabel = "item" }) {
  if (!count) return null;
  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-[color:var(--aisensy-dark)] text-white rounded-md px-4 py-2 flex items-center gap-4"
      data-testid="bulk-bar"
    >
      <span className="text-sm tabular">
        {count} {entityLabel}{count === 1 ? "" : "s"} selected
      </span>
      <Button
        size="sm"
        variant="ghost"
        onClick={onClear}
        className="h-7 px-2 text-white/80 hover:text-white hover:bg-white/10"
        data-testid="bulk-clear"
      >
        Clear
      </Button>
      {onDuplicate && (
        <Button
          size="sm"
          onClick={onDuplicate}
          className="h-7 px-3 bg-white/10 hover:bg-white/20 text-white"
          data-testid="bulk-duplicate"
        >
          <Copy className="w-3.5 h-3.5 mr-1" /> Duplicate {count}
        </Button>
      )}
      <Button
        size="sm"
        onClick={onDelete}
        className="h-7 px-3 bg-[color:var(--overdue)] hover:opacity-90 text-white"
        data-testid="bulk-delete"
      >
        <Trash2 className="w-3.5 h-3.5 mr-1" /> Delete {count}
      </Button>
    </div>
  );
}
